import React from "react";
import Navbar from "../components/landing/Navbar";
import HeroSectionNew from "../components/landing/HeroSectionNew";
import HowItWorksNew from "../components/landing/HowItWorksNew";
import ValueProposition from "../components/landing/ValueProposition";
import BenefitsGrid from "../components/landing/BenefitsGrid";
import TestimonialsSection from "../components/landing/TestimonialsSection";
import FAQSection from "../components/landing/FAQSection";
import CTASection from "../components/landing/CTASection";
import FooterNew from "../components/landing/FooterNew";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSectionNew />
      <HowItWorksNew />
      <ValueProposition />
      <BenefitsGrid />
      <TestimonialsSection />
      <FAQSection />
      <CTASection />
      <FooterNew />
    </div>
  );
};

export default HomePage;
